import React, { useRef, useState, useEffect } from 'react';
import { partners } from '../data/i18n';

const Partners = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Create duplicate array for infinite scroll effect
  const duplicatedPartners = [...partners, ...partners, ...partners];

  return (
    <section ref={sectionRef} className="py-12 md:py-16 bg-gray-50 dark:bg-gray-800 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className={`text-center text-gray-500 dark:text-gray-400 text-sm tracking-widest uppercase mb-8 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          Parceiros e Certificações
        </h3>

        {/* Infinite scroll container */}
        <div className="relative">
          <div className={`flex items-center gap-12 animate-scroll ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}>
            {duplicatedPartners.map((partner, index) => (
              <div
                key={`${partner.id}-${index}`}
                className="flex-shrink-0 w-40 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300 hover:scale-105"
              >
                <div className="bg-white dark:bg-gray-700 rounded-lg p-3 shadow-sm w-full h-full flex items-center justify-center">
                  {partner.logo ? (
                    <img 
                      src={partner.logo} 
                      alt={partner.name}
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    <span className="text-gray-600 dark:text-gray-300 font-semibold text-sm">
                      {partner.name}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
